export default function Marquee() {
  const text = "TRANSFORMING STRUCTURES · ENSURING DURABILITY · ";
  const items = Array(4).fill(text).join("");
  return (
    <section className="border-y border-border bg-primary py-5 overflow-hidden select-none" data-testid="marquee">
      <div className="flex whitespace-nowrap">
        <div className="animate-marquee flex shrink-0">
          <span className="font-display text-2xl md:text-4xl font-black uppercase tracking-tight text-primary-foreground/95 pr-4">
            {items}
          </span>
          <span className="font-display text-2xl md:text-4xl font-black uppercase tracking-tight text-primary-foreground/95 pr-4" aria-hidden="true">
            {items}
          </span>
        </div>
      </div>
    </section>
  );
}
